import { ReactNode } from 'react';
import { IOperation } from '@/common/integrations/menhir/employee/operations/operations.types';
import { usePageViewTracking } from '@/web/hooks/usePageViewTracking';
import { Drawer } from '@coverflex-tech/hypernova';
import { useRouter } from 'expo-router';

interface IOperationDetailDrawerProps {
  operation: IOperation;
  title?: string;
  children?: ReactNode;
  isLoading?: boolean;
}

export const OperationDetailDrawer = ({
  operation,
  children,
  title,
  isLoading,
}: IOperationDetailDrawerProps) => {
  const { setParams } = useRouter();

  usePageViewTracking('operation_detail_page', {
    operation_status: operation?.status,
    operation_rejected_reason:
      (operation?.descriptionParams?.find(
        (param) => param.key === 'rejection_reason'
      )?.value as string) ?? ('generic_error' as string),
  });

  return (
    <Drawer
      onClose={() => setParams({ operationId: undefined })}
      title={title}
      isLoading={isLoading}
    >
      {children}
    </Drawer>
  );
};
